/* eslint-disable no-useless-escape */
export class URLSearch {
  static getParameterByName(name: string, url = window.location.href): string {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) {
      if (sessionStorage.getItem("***")) {
        return sessionStorage.getItem("***") as string;
      }
      return "";
    }
    if (!results[2]) {
      if (sessionStorage.getItem("***")) {
        return sessionStorage.getItem("***") as string;
      }
      return "";
    }
    return decodeURIComponent(results[2].replace(/\=/g, " "));
  }
  
  static getLastPath(): string {
    const url = window.location.href
    const paths: string[] = url.split("lastPath=")
    let path = ""
    if(paths.length > 0) {
        path = paths[4]
        return path
    }
    else {
        return path
    }
  }
}
